function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "321-play-logo-web");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  id: "svg_1"
}, React.createElement("g", {
  id: "svg_2"
}, React.createElement("path", {
  id: "svg_3",
  fill: "#00a3e0",
  d: "m15.181,54.232a16.188,16.188 0 0 1 -11.526,-4.775a6,6 0 0 1 8.484,-8.484a4.3,4.3 0 1 0 3.042,-7.342a6,6 0 0 1 0,-12a16.3,16.3 0 0 1 0,32.6l0,0.001z"
}), React.createElement("path", {
  id: "svg_4",
  fill: "#45dcff",
  d: "m15.181,33.612a6,6 0 0 1 0,-12a4.3,4.3 0 1 0 -3.042,-7.341a6,6 0 1 1 -8.484,-8.485a16.3,16.3 0 1 1 11.526,27.826z"
})), React.createElement("g", {
  id: "svg_5"
}, React.createElement("path", {
  id: "svg_6",
  fill: "#a2eb00",
  d: "m59.739,30.6a6,6 0 0 1 -4.239,-10.248a4.3,4.3 0 1 0 -6.08,-6.082a6,6 0 0 1 -8.488,-8.483a16.3,16.3 0 1 1 23.053,23.052a5.988,5.988 0 0 1 -4.246,1.761z"
}), React.createElement("path", {
  id: "svg_7",
  fill: "#a2eb00",
  d: "m52.016,38.319a6,6 0 0 1 -4.243,-10.242l7.723,-7.724a6,6 0 0 1 8.487,8.485l-7.724,7.724a5.986,5.986 0 0 1 -4.243,1.757z"
}), React.createElement("path", {
  id: "svg_8",
  fill: "#d050e4",
  d: "m62.757,54.232l-20.6,0a6,6 0 0 1 0,-12l20.6,0a6,6 0 0 1 0,12z"
})), React.createElement("g", {
  id: "svg_9"
}, React.createElement("path", {
  id: "svg_10",
  fill: "#45dcff",
  d: "m87,54.232a6,6 0 0 1 -6,-6l0,-41.221a6,6 0 1 1 12,0l0,41.221a6,6 0 0 1 -6,6z"
}), React.createElement("path", {
  id: "svg_11",
  fill: "#d050e4",
  d: "m78.986,21.028a6,6 0 0 1 -4.244,-10.242l8.017,-8.017a6,6 0 0 1 8.486,8.485l-8.016,8.017a5.986,5.986 0 0 1 -4.243,1.757z"
})), React.createElement("path", {
  id: "svg_12",
  fill: "#ff6500",
  d: "m200.329,56.1a6,6 0 0 1 -6,-6l0,-42.927a6,6 0 0 1 12,0l0,42.927a6,6 0 0 1 -6,6z"
}), React.createElement("g", {
  id: "svg_13"
}, React.createElement("path", {
  id: "svg_14",
  fill: "#d050e4",
  d: "m326.743,11.873a6,6 0 0 1 -6,-6l0,-1.973a6,6 0 1 1 12,0l0,1.976a6,6 0 0 1 -6,5.997zm-40.9,0a6,6 0 0 1 -6,-6l0,-1.973a6,6 0 1 1 12,0l0,1.976a6,6 0 0 1 -5.997,5.997l-0.003,0z"
}), React.createElement("path", {
  id: "svg_15",
  fill: "#45dcff",
  d: "m306.294,50.776a26.45,26.45 0 0 1 -26.448,-26.448a6,6 0 1 1 12,0a14.449,14.449 0 1 0 28.9,0a6,6 0 0 1 12,0a26.448,26.448 0 0 1 -26.449,26.448l-0.003,0z"
}), React.createElement("path", {
  id: "svg_16",
  fill: "#d050e4",
  d: "m306.294,56.1a6,6 0 0 1 -6,-6l0,-5.324a6,6 0 0 1 12,0l0,5.324a6,6 0 0 1 -6,6z"
})), React.createElement("g", {
  id: "svg_17"
}, React.createElement("path", {
  id: "svg_18",
  fill: "#a2eb00",
  d: "m240.629,56.1a26.449,26.449 0 1 1 26.449,-26.449a26.478,26.478 0 0 1 -26.449,26.449zm0,-40.9a14.449,14.449 0 1 0 14.449,14.448a14.464,14.464 0 0 0 -14.449,-14.448z"
}), React.createElement("path", {
  id: "svg_19",
  fill: "#45dcff",
  d: "m263.106,56.1a6,6 0 0 1 -6,-6l0,-42.927a6,6 0 0 1 12,0l0,42.927a6,6 0 0 1 -6,6z"
})), React.createElement("g", {
  id: "svg_20"
}, React.createElement("path", {
  id: "svg_21",
  fill: "#45dcff",
  d: "m160.03,54.07a26.448,26.448 0 0 1 -18.7,-45.151l0,0a26.449,26.449 0 1 1 18.7,45.151zm0,-40.89a14.4,14.4 0 0 0 -10.217,4.225l0,0a14.465,14.465 0 1 0 10.217,-4.225zm-14.459,-0.018l0,0z"
}), React.createElement("path", {
  id: "svg_22",
  fill: "#00a3e0",
  d: "m137.553,56.1a6,6 0 0 1 -6,-6l0,-42.927a6,6 0 0 1 12,0l0,42.927a6,6 0 0 1 -6,6z"
})), React.createElement("path", {
  id: "svg_23",
  fill: "#d050e4",
  d: "m113.826,33.6l-5.321,0a6,6 0 0 1 0,-12l5.321,0a6,6 0 0 1 0,12z"
})));

var SvgColorLogo = function SvgColorLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "340mm",
    height: "58mm",
    viewBox: "0 0 340 58",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgColorLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/colorLogo.95f24799.svg";
export { ForwardRef as ReactComponent };